import { playerTimeShift } from "./playerLiveUtils";
import PlayerConstants from "../../../shared/constants/player";
import { getCurrentTimestamp } from "../core/playerUtils";

const { PLAYBACK_FORWARD_BUFFER } = PlayerConstants;

export const playerAdjustRecordingSeekablePos = (
  newPos,
  playerMgr,
  recordingStartDeltaTime,
  recordingStopDeltaTime,
  recordingLiveAssetStartTime
) => {
  if (recordingStartDeltaTime !== null && !playerMgr.current?.isLive()) {
    newPos = newPos <= recordingStartDeltaTime ? recordingStartDeltaTime : newPos;
  }

  if (recordingStopDeltaTime !== null && !playerMgr.current?.isLive()) {
    newPos = newPos >= recordingStopDeltaTime ? recordingStopDeltaTime - 1 : newPos;
  }

  if (recordingLiveAssetStartTime.current && newPos < recordingLiveAssetStartTime.current) {
    newPos = recordingLiveAssetStartTime.current;
  }

  return newPos;
};

export const playerUpdateDynamicRecordingProgress = (
  playerMgr,
  progress,
  recordingLiveAssetStartTime,
  recordingPlaybackDuration,
  displayToastNotification,
  isSafari,
  userRecordingStartTimeRef
) => {
  const progressPOS =
    parseInt(recordingLiveAssetStartTime.current) +
    Math.round((parseInt(recordingPlaybackDuration.current) * parseInt(progress)) / 100);

  if (
    playerMgr.current?.isInProgress() &&
    progressPOS > parseInt((getCurrentTimestamp() - userRecordingStartTimeRef.current - PLAYBACK_FORWARD_BUFFER) / 1000)
  ) {
    displayToastNotification("live_position_reached");
    return;
  } else if (progressPOS > parseInt((getCurrentTimestamp() - PLAYBACK_FORWARD_BUFFER) / 1000)) {
    displayToastNotification("live_position_reached");
    return;
  }

  if (isSafari) {
    playerTimeShift(playerMgr, progressPOS + PLAYBACK_FORWARD_BUFFER);
  } else {
    playerTimeShift(playerMgr, progressPOS);
  }
};

export const shakaHlsUpdateDynamicRecordingProgress = (
  playerMgr,
  progress,
  recordingStartDeltaTime,
  recordingPlaybackDuration,
  displayToastNotification
) => {
  let progressPOS =
    parseInt(recordingStartDeltaTime) +
    Math.round((parseInt(recordingPlaybackDuration.current) * parseInt(progress)) / 100);

  if (progressPOS > playerMgr.current?.getSeekRange().end) {
    displayToastNotification("live_position_reached");
    progressPOS = playerMgr.current?.getSeekRange().end;
  }
  playerTimeShift(playerMgr, progressPOS);
};
